import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function ProtectedRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="container mx-auto px-4 py-8">Loading...</div>;
  }

  return user ? <Outlet /> : <Navigate to="/auth" />;
}

export default ProtectedRoute; 